<template>
    <div class="bg" :style="{
        'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
        'backgroundColor': '#f5f5f5' // 添加备用背景色
    }">
        <div class="logo_wrap ">
            <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
            <div class="logo_right">
                <div class="power">{{ $t('PoweredbyMVGX') }}</div>
                <!-- <div class="right_top_txt_shu">|</div>
                <Kefu :sn="sn"></Kefu> -->
            </div>
        </div>
        <div class="progress_wrap">
            <img v-if="$i18n.locale == 'en'" src="../assets/img/progress.png" alt="" class="progress" />
            <img v-else src="../assets/img/progress_cn.png" alt="" class="progress" />
        </div>
        <div class="title">
            <div>
                <span class="nums">{{ certificateDetail.neutralizeAmount }}</span>
                <span class="tons"> kgCO₂e</span>
            </div>
            <div class="title_con">{{ $t('CarbonFootprintNeutralized') }}</div>
        </div>
        <div class="m_rl_20 content">
            <div class="content_title">
                {{ $t('ThankYouforNeutralizing') }}
            </div>
            <ul class="list">
                <li>
                    <div class="list_name">{{ $t('NAME') }}:</div>
                    <div>{{ certificateDetail.name }}</div>
                </li>
                <li v-if="certificateDetail.eventName">
                    <div class="list_name">{{ $t('EVENTNAME') }}:</div>
                    <div>{{ certificateDetail.eventName }}</div>
                </li>
                <!-- <li>
          <div class="list_name">ISSUER:</div>
          <div>METAVERSE GREEN EXCHANGE PTE LTD</div>
        </li> -->
                <li>
                    <div class="list_name">{{ $t('CARBONNEUTRALISATION') }}:</div>
                    <div>
                        <!-- <a :href="certificateDetail.contractUrl"> -->
                        {{ certificateDetail.transactionId }}
                        <!-- </a> -->
                    </div>
                </li>
                <li>
                    <div class="list_name">{{ $t('CARBONFOOTPRINT') }}:</div>
                    <div>
                        {{ certificateDetail.neutralizeAmount }} kg OF CO2 {{ $t('EQUIVALENT') }} 
                    </div>
                </li>
                <li>
                    <div class="list_name">{{ $t('DATEOFCARBON') }}:</div>
                    <div v-if="$i18n.locale == 'en'">{{ certificateDetail.burntDate ? formatDate(certificateDetail.burntDate) : '--' }}</div>
                    <div v-else>{{ certificateDetail.burntDate ? formatDatey(certificateDetail.burntDate) : '--' }}</div>
                </li>

            </ul>
        </div>
        <!-- <div class="cen">
            <img src="../assets/img/loading.png" alt="" class="loading">
        </div> -->
        <div class="con">
            {{ $t('Your') }} {{ certificateDetail.eventName || '' }} {{ $t('tripcarbon') }}
        </div>
        <el-row type="flex" :gutter="20" class="btn_wrap">
            <el-col>
                <el-button class="btn" @click="downLoad">{{ $t('DownloadCertificate') }}</el-button>
            </el-col>
            <!-- <el-col>
        <el-button class="btn btn_world" @click="nft">Purchase NFT</el-button>
      </el-col> -->
        </el-row>
    </div>
</template>
<script>
import cnt from "@/api/cnt";
import { formatDate, formatDatey } from "@/util/date";
import Kefu from '@/components/kefu.vue'
export default {
    components: { Kefu },
    data() {
        return {
            sn: "",
            certificateDetail: {},
            userinfo: '',
            config: '',
        };
    },
    created() {
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
    },
    mounted() {
        this.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
        // this.userinfo = JSON.parse(sessionStorage.getItem('activityInfo'))
        this.getuserInfo()
        // this.getUserEvent(1,1)
    },
    methods: {
        formatDate: formatDate,
        formatDatey: formatDatey,
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        getuserInfo() {
            let user = JSON.parse(sessionStorage.getItem('user'))
            let params = {
                // userId: user.id,
                sn: this.sn
            }
            cnt.getuserInfo(res => {
                if (res.code == 200) {
                    this.certificateDetail = res.data
                }
            }, params)
        },
        downLoad() {
            cnt.getpdf(
                (res) => {
                    console.log("res", '下载');
                    this.$router.push({ path: "/carsuccess", query: { sn: this.sn } });
                    // this.$router.push({ path: "/certificateTemplate", query: { sn: this.sn } });
                },
                { sn: this.sn }
            );
        },
        nft() {
            // this.$router.push({ path: "/detail", query: { sn: this.sn } });
            this.$router.push({ path: "/success", query: { sn: this.sn } });
        }
    },
};
</script>
<style lang="less" scoped>
a {
    text-decoration: none;
    font-size: 0.8125rem;
    color: #000000;
}

.bg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    overflow-y: auto;
    // background: url('../assets/img/bj.png') no-repeat;
    background-repeat: no-repeat;
    // position: relative;
    background-size: 100% 100%;
}

.logo_wrap {
    padding: 20px 20px 0;
    display: flex;
    justify-content: space-between;
    align-content: center;

    .logo {
        width: auto;
    }

    .logo_right {
        display: flex;
        align-items: center;
    }

    .right_top_txt_shu {
        margin: 0 12px;
        color: #EDFFFE;
    }

    .power {
        font-size: .75rem;
        font-family: Century Gothic;
        color: #EDFFFE;
    }
}

.progress {
    width: 20.8438rem;
    height: 2.5625rem;
}

.title {
    margin: 15px 20px;
    font-size: 1.625rem;
    color: #fff;
    text-align: center;
    font-family: Arial-BoldMT, Arial;
}

.nums {
    font-size: 3rem;
    font-weight: bold;
}

.tons {
    font-size: 0.75rem;
    color: #d3e6ea;
}

.title_con {
    font-size: 0.8125rem;
    font-family: Century Gothic;
}

.content {
    background-color: #ffffff;
    border-radius: 1.25rem;
    padding: 1.5625rem 1.25rem;
}

.content_title {
    font-size: 1.1875rem;
    font-family: Century Gothic;
    font-weight: normal;
    color: #1e1e1e;
    text-align: center;
}

.list {
    margin-top: 1.25rem;
    font-size: 0.8125rem;
    color: #000000;

    div:last-child {
        white-space: normal;
        word-break: break-all;
    }
}

.list>li {
    list-style: none;
    padding: 0.6875rem 0;
    border-bottom: 0.0625rem solid #e6f0f2;
}

.list_name {
    font-size: 0.75rem;
    color: #4d94a0;
    margin-bottom: 0.4375rem;
}

.cen {
    display: flex;
    justify-content: center;
    align-content: center;
    margin: 0.9375rem 0 1.25rem;
}

@keyframes rotateLoad {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.loading {
    animation: rotateLoad 3s linear infinite;
    width: 1.75rem;
    height: 1.75rem;
}

.con {
    margin: 1.25rem 1.5rem 1.875rem;
    font-size: 0.9375rem;
    font-family: Century Gothic;
    color: #ffffff;
}

.btn_wrap {
    margin: 0 !important;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
}

.btn {
    width: 100%;
    height: 2.8125rem;
    color: #4d94a0;
    margin-bottom: 1.3125rem;
    border-radius: 0.625rem;
    font-size: 0.9375rem;
    font-family: Century Gothic;
    box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
    padding: 0;
}

.el-button+.el-button {
    margin: 0;
}

.btn_world {
    background-color: rgba(255, 255, 255, 0.13);
    backdrop-filter: blur(0.3125rem);
    border: 0.0625rem solid #ffffff;
    color: #fff;
}

.progress_wrap {
    width: 100%;
    height: 2.5625rem;
    margin-top: 40px;
    display: flex;
    justify-content: center;
}
</style>
